<template>
  <div>
    <div class="extensao_banner">
      <BreadCrumb :breadcrumb="breadcrumb" class="bcp" />
      <h1>SASUMA / {{ $t("UMA_LANG_SASUMA_BOLSAS_TITULO") }}</h1>
    </div>

    <div class="row align-center bolsas_sas_imgs">
      <div style="position: absolute; display: contents;"
        class="small-10 medium-10 large-9 columns">
        <div class="row">
          <BotaoBolsa :bolsa="bolsa" v-for="bolsa in bolsas" :key="bolsa.name" />
        </div>
      </div>
    </div>

    <div class="row align-center">
      <div class="small-10 medium-10 large-9 columns bolsaslist">
        <p class="introbolsatexto" v-html="$t('UMA_LANG_SASUMA_BOLSAS_TEXTO')"></p>
      </div>
    </div>

    <div class="row align-center logosrows">
      <div class="small-10 medium-10 large-9 columns">
        <div class="row">
          <Logo :src="sas_logo1" />
          <Logo :src="sas_logo2" />
          <Logo :src="sas_logo3" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ref } from "vue";
import { i18n } from "@/main.js";
//import { BreadCrumb } from "umaui";
import BreadCrumb from "@/components/BreadCrumb.vue";
import axios from "@/axios";
import BotaoBolsa from "@/components/BotaoBolsa.vue";
import { onBeforeRouteLeave } from 'vue-router'
import Logo from "@/components/Logo.vue";

import sas_logo1 from "@/assets/images/sas_logo1.png";
import sas_logo2 from "@/assets/images/sas_logo2.png";
import sas_logo3 from "@/assets/images/sas_logos3.png";

export default {
  components: {
    BreadCrumb,
    BotaoBolsa,
    Logo
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    const breadcrumb = ref([
      { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
      { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
      { ID: 2, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
      { ID: 2, text: t("breadcrumb.sas"), route: { to: "/" } },
      { ID: 3, text: t("breadcrumb.bolsas"), href: "#" }
    ]);

    const bolsas = ref([]);

    axios.get("/bolsassas").then(response => {
      bolsas.value = response.data.map(el => {
        return {
          ...el,
          ordem: el.Ordem == 0 ? Number.MAX_SAFE_INTEGER : el.Ordem
        }
      }).sort((a, b) => a.ordem - b.ordem);
    }).catch(error => {
      console.log(error);
    })

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      console.log("onBeforeRouteLeave")
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    return {
      bolsas,
      breadcrumb,
      sas_logo1,
      sas_logo2,
      sas_logo3
    }
  }
}
</script>

<style lang="scss" scoped>
.extensao_banner h1 {
  text-align: center;
  font-family: "Montserrat Bold";
  font-size: 60px;
  color: #3f4244;
  padding-top: 105px;
  padding-bottom: 30px;
  transform: translate3D(0, -10px, 0);
}

.extensao_banner h1 {
  font-size: 55px;
  color: #4d5354;
}

.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 25px !important;
    padding-top: 35px;
    padding-bottom: 0px;
  }
}

.bolsaslist {
  padding-right: 0;
  padding-left: 0;
  max-width: 1330px;
}

@media (max-width: 1350px) {
  .bolsaslist {
    padding-right: 0;
    padding-left: 0;
    max-width: 100%;
  }
}

@media (max-width: 1280px) {
  .bolsaslist {
    padding-left: 0;
    padding-right: 0;
  }
}

.introbolsatexto {
  margin-top: 60px;
  margin-left: 10px;
  margin-right: 10px;
  padding-right: 15px;
  padding-left: 50px;
  font-size: 17px;
  font-family: "Montserrat Light";
  line-height: 2.3;
  color: #494d52eb;
  margin-bottom: 90px;
}

@media (max-width: 1400px) {
  .introbolsatexto {
    margin-left: 0px;
    margin-right: 0px;
    padding-right: 0px;
    padding-left: 0px;
    margin-top: 30px;
  }
}

@media (max-width: 767px) {
  .introbolsatexto {
    font-size: 14px;
    line-height: 2;
    color: #333333;
    margin-top: 0px;
    margin-bottom: 40px;
    padding-top: 15px;
    padding-right: 0px;
    padding-left: 0px;
  }
}

.logosrows {
  margin-top: 0px;
  margin-bottom: 100px;
}

@media (max-width: 1400px) {
  .logosrows {
    margin-top: 0px;
    margin-bottom: 160px;
  }
}

@media (max-width: 767px) {
  .logosrows {
    margin-top: 0px;
  }

  .logosrows {
    margin-top: 0px;
    margin-bottom: 40px;
  }

}

@media (max-width: 1400px) {
  .bolsas_sas_imgs .row {
    display: contents;
  }
}

@media (max-width: 900px) {
  .bolsas_sas_imgs {
    margin-right: 100px;
    margin-left: 100px;
  }
}

@media (max-width: 700px) {
  .bolsas_sas_imgs {
    margin-right: 0px;
    margin-left: 0px;
  }
}

@media (max-width: 767px) {
  .large-9 {
    flex: 0 0 100%;
  }

  .bolsaslist {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>